import {
    newUserSocialMediaLinkArray,
    userSocialMediaLink,
  } from "./userSocialMediaLink";

export interface UserProfile {
    Id?: string;
    FirstName: string;
    LastName: string;
    Email: string;
    Biography: string;
    PictureLink?: string;
    SocialMediaLinks?: userSocialMediaLink[];
    PresentationSessions: UserPresentation[];
};
export class UserPresentation {
    public EventId: string | undefined;
    public SessionId: string | undefined;
    public constructor(init?:Partial<UserPresentation>) {
        Object.assign(this, init);
    }
    public equals(obj: UserPresentation) : boolean { 
        return this.EventId === obj.EventId && this.SessionId === obj.SessionId;
    } 
  };
  
export function newUserProfile():UserProfile{
    return {
        Id: "",
        FirstName:"",
        LastName:"",
        Email:"",
        Biography:"",
        PictureLink:"",
        SocialMediaLinks: newUserSocialMediaLinkArray(),
        PresentationSessions:[],
    };
};
export function newUserProfileArray():UserProfile[]{
    return [];
};